// extracted by extract-css-chunks-webpack-plugin
module.exports = {"copyCode":"ReferralPageAppDownloadPrompt-c962e6319d92555e","appStoreBadge":"ReferralPageAppDownloadPrompt-40fcfdb8f784106e"};